import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconChevronDownModule } from "@mk/med-icons";

import { MedAccordionComponent } from "./med-accordion.component";

@NgModule({
  declarations: [
    MedAccordionComponent,
  ],
  imports: [
    CommonModule,
    MedIconChevronDownModule,
  ],
  exports: [
    MedAccordionComponent,
  ],
})
export class MedAccordionModule { }
